import {Module, VuexModule, Mutation, Action, getModule} from 'vuex-module-decorators';
import store from '../index';
import axios from 'axios';

const baseUrl = process.env.VUE_APP_API_URL;

@Module({
    name: 'api',
    dynamic: true,
    namespaced: true,
    store,
})
class ModuleApi extends VuexModule {
    @Action
    async GET(url: string): Promise<any> {
        const savedToken = localStorage.getItem("token")
        const response = await axios.get(baseUrl + url, {headers: {'CabinetSession': savedToken}});
        return response.data;
    }

    @Action
    async POST(rq: { url: string, body: any }): Promise<any> {
        const savedToken = localStorage.getItem("token")
        const response = await axios.post(baseUrl + rq.url, rq.body, {headers: {'CabinetSession': savedToken}});
        return response.data;
    }

    @Action
    async PUT(rq: { url: string, body: any }): Promise<any> {
        const savedToken = localStorage.getItem("token")
        const response = await axios.put(baseUrl + rq.url, rq.body, {headers: {'CabinetSession': savedToken}});
        return response.data;
    }

    @Action
    async DELETE(url: string): Promise<any> {
        const savedToken = localStorage.getItem("token")
        const response = await axios.delete(baseUrl + url, {headers: {'CabinetSession': savedToken}});
        return response.data;
    }
}

export default getModule(ModuleApi);
